<template>
    <div class="tw-flex tw-items-start tw-content-center tw-relative">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h3>Obrigado pelo <br>seu registo. </h3><br>
            <p>Em breve iremos entrar em contacto consigo.</p><br>
            <p>Saiba mais sobre os pacotes Dish em <a href="https://www.dish.co/2">https://www.dish.co/2</a></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import "~@/assets/scss/partials/_variables.scss";

.form-success {
    padding: 18px 16px;
    background-color: $makro-blue;

    @screen lg {
        padding: 66px 35px 86px;
        max-width: 400px;
        border-radius: 0 0 30px 30px;
    }

    h3 {
        color: $makro-yellow;

        @screen lg {
            font-size: 28px;
        }
    }

    p {
        color: #fff;
        font-size: 16px;

        a {
            color: $makro-yellow;
        }
    }
}

</style>
